import {IntlShape} from 'react-intl'

/**
 * gori-partner-api reuses the same "<field>|<CODE>" convention as other
 * import/validate APIs for some field errors (e.g. the `email` field on
 * `POST /auth/reset-password`): `error|INPUT_IS_NOT_A_VALID_EMAIL_ADDRESS`.
 * Other fields may just return a plain, already human-readable message
 * (Laravel's default rule messages, e.g. "The email field is required.").
 *
 * This helper translates the former via i18n and falls back to displaying
 * the raw string for the latter.
 */
export function formatApiFieldError(intl: IntlShape, error: string): string {
  if (!error) return ''

  const [input, messageId] = error.split('|')
  if (!messageId) {
    // Plain message (e.g. Laravel's default "required" rule message).
    return input
  }

  return intl.formatMessage(
    {id: messageId, defaultMessage: error},
    {input: intl.formatMessage({id: input?.toUpperCase(), defaultMessage: input})}
  )
}
